<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <!-- PDF Generator -->

        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          :filename="filename"
          :pdf-quality="1"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="landscape"
          pdf-content-width="100%"

          ref="html2Pdf"
        >
          <section class="p-10" slot="pdf-content">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="vx-row">
                  <div class="vx-col w-1/3 mt-base">

                  </div>
                  <div class="vx-col w-1/3 mt-base text-center">
                    <div class="titre_etat_regl">
                      <h1>Etat BR</h1>
                    </div>
                  </div>
                  <div class="vx-col w-1/3 mt-base text-right">
                    <!-- {{proforma.createdAt | moment("calendar", "July 10 2011") }} -->
                    <h4>Officine: {{officineName}} </h4>
                  </div>
                </div>
                <div class="vx-row mt-5">
                  <div class="vx-col w-full text-center">
                    <h4>Période du {{DateDebut | moment("calendar", "July 10 2011") }} au {{DateFin | moment("calendar", "July 10 2011") }}</h4>
                  </div>
                </div>
                <div class="vx-row mt-5">
                  <table class="w-full customtable" cellpadding="0" cellspacing="0">
                    <thead>
                      <tr>
                        <th class="customth" colspan="1" style="border-right-width: 0px;" >N°br</th>
                        <th class="customth" colspan="1" style="border-right-width: 0px;">Date</th>
                        <th class="customth" colspan="1" style="border-right-width: 0px;">Status</th>
                        <th class="customth" colspan="2" style="border-right-width: 0px;">Four</th>
                        <th class="customth text-center" colspan="1" style="border-right-width: 0px;">Qte article</th>
                        <th class="customth" colspan="1" style="border-right-width: 0px;">PA</th>
                        <th class="customth" colspan="1" style="border-right-width: 0px;">PVHT</th>
                        <th class="customth" colspan="1" >PVTTC</th>
                      </tr>
                    </thead>
                    <!-- v-if="br.length >0" -->
                    <tbody>
                      <tr :key="indextr" v-for="(tr, indextr) in br">
                        <td class="customtd" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{tr.CodeCmde}}</td>
                        <td class="customtd" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{tr.DateComdF | moment("calendar", "July 10 2011") }}</td>
                        <td class="customtd" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{tr.status}}</td>
                        <td class="customtd" colspan="2" style="border-right-width: 0px;border-bottom-width: 0px;">{{getFournisseurName(tr.IdFour)}}</td>
                        <td class="customtd text-center" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{tr.details.length}}</td>
                        <td class="customtd text-right" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{paArticleBr(tr.details)}}</td>
                        <td class="customtd text-right" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{pvHtArticleBr(tr.details)}}</td>
                        <td class="customtd text-right" colspan="1" style="border-bottom-width: 0px;">{{pvTtcArticleBr(tr.details)}}</td>

                      </tr>
                    </tbody>

                    <tfoot>
                      <tr>
                        <th class="customtd text-center" colspan="5" style="border-right-width: 0px;">TOTAL</th>
                        <th class="customtd text-center" colspan="1" style="border-right-width: 0px;">{{totalQteArticleBr}}</th>
                        <th class="customtd text-right" colspan="1" style="border-right-width: 0px;">{{totalPaArticleBr}}</th>
                        <th class="customtd text-right" colspan="1" style="border-right-width: 0px;">{{totalPvHtArticleBr}}</th>
                        <th class="customtd text-right" colspan="1">{{totalPvTtcArticleBr}}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>

      <!-- PDF Generator end -->
      <vx-card ref="filter_card" :refreshContentAction="true" @refresh="RefreshContent()">
        <div class="vx-row">
          <div class="vx-col md:w-1/6 mt-4">
            <label class="text-sm">Date Debut</label>
            <flat-pickr v-model.lazy="DateDebut" :config="{ dateFormat: 'd F Y'}" class="w-full" name="DateDebut" />
          </div>
          <div class="vx-col md:w-1/6 mt-4">
            <label class="text-sm">Date Fin</label>
            <flat-pickr v-model.lazy="DateFin" :config="{ dateFormat: 'd F Y'}" class="w-full" name="DateFin" />
          </div>
          <div class="vx-col md:w-1/6 mt-4">
            <vs-select v-if="principale" label="Officine" autocomplete class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="idOfficine" @change="onSelectOfficine(idOfficine)">
              <vs-select-item  class="w-full" :key="index" :value="item._id" :text="item.NomOffic" v-for="(item,index) in officines" />
            </vs-select>
          </div>
          <div class="vx-col md:w-1/6 mt-4">
            <vs-select label="Status" autocomplete class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="status">
              <vs-select-item  class="w-full" :key="index" :value="item" :text="item" v-for="(item,index) in ['En edition','En attente de validation','Commande transferée']" />
            </vs-select>
          </div>
          <div class="vx-col md:w-1/6 mt-10">
            <vs-button ref="loadableButton" id="button-with-loading" class="w-full vs-con-loading__container" color="primary" icon-pack="feather" icon="icon-search" @click="getBROnSpecifiquePeriode()">VALIDER</vs-button>
          </div>
          <div class="vx-col md:w-1/6 mt-10">
            <vs-button id="pdf-button-with-loading" class="w-full vs-con-loading__container" color="primary" icon-pack="feather" icon="icon-file" @click="printBrToPdf()">IMPRESSION</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
    <div  class="vx-col w-full mt-5">
      <vx-card id="corps-proforma">
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col w-1/3 mt-base">

              </div>
              <div class="vx-col w-1/3 mt-base text-center">
                <div class="titre_etat_regl">
                  <h1>Etat BR</h1>
                </div>
              </div>
              <div class="vx-col w-1/3 mt-base text-right">
                <!-- {{proforma.createdAt | moment("calendar", "July 10 2011") }} -->
                <h4>Officine: {{officineName}} </h4>
              </div>
            </div>
            <div class="vx-row mt-5">
              <div class="vx-col w-full text-center">
                <h4>Période du {{DateDebut | moment("calendar", "July 10 2011") }} au {{DateFin | moment("calendar", "July 10 2011") }}</h4>
              </div>
            </div>
            <div class="vx-row mt-5">
              <table class="w-full" cellpadding="0" cellspacing="0">
                <thead>
                  <tr>
                    <th class="customth" colspan="1" style="border-right-width: 0px;" >N°br</th>
                    <th class="customth" colspan="1" style="border-right-width: 0px;">Date</th>
                    <th class="customth" colspan="1" style="border-right-width: 0px;">Status</th>
                    <th class="customth" colspan="2" style="border-right-width: 0px;">Four</th>
                    <th class="customth text-center" colspan="1" style="border-right-width: 0px;">Qte article</th>
                    <th class="customth" colspan="1" style="border-right-width: 0px;">PA</th>
                    <th class="customth" colspan="1" style="border-right-width: 0px;">PVHT</th>
                    <th class="customth" colspan="1" >PVTTC</th>
                  </tr>
                </thead>
                <!-- v-if="br.length >0" -->
                <tbody>
                  <tr :key="indextr" v-for="(tr, indextr) in br">
                    <td class="customtd" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">
                      <span class="cursor: pointer" @click="goToDetailFacture(tr._id)">
                        {{tr.CodeCmde}}
                      </span>
                    </td>
                    <td class="customtd" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{tr.DateComdF | moment("calendar", "July 10 2011") }}</td>
                    <td class="customtd" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{tr.status}}</td>
                    <td class="customtd" colspan="2" style="border-right-width: 0px;border-bottom-width: 0px;">{{getFournisseurName(tr.IdFour)}}</td>
                    <td class="customtd text-center" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{tr.details.length}}</td>
                    <td class="customtd text-right" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{paArticleBr(tr.details)}}</td>
                    <td class="customtd text-right" colspan="1" style="border-right-width: 0px;border-bottom-width: 0px;">{{pvHtArticleBr(tr.details)}}</td>
                    <td class="customtd text-right" colspan="1" style="border-bottom-width: 0px;">{{pvTtcArticleBr(tr.details)}}</td>

                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <th class="customth text-center" colspan="5" style="border-right-width: 0px;">TOTAL</th>
                    <th class="customth text-center" colspan="1" style="border-right-width: 0px;">{{totalQteArticleBr}}</th>
                    <th class="customth text-right" colspan="1" style="border-right-width: 0px;">{{totalPaArticleBr}}</th>
                    <th class="customth text-right" colspan="1" style="border-right-width: 0px;">{{totalPvHtArticleBr}}</th>
                    <th class="customth text-right" colspan="1">{{totalPvTtcArticleBr}}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
/* lazy loading Vue components */
const flatPickr = () => import('vue-flatpickr-component')
import 'flatpickr/dist/flatpickr.css'
const VueHtml2pdf = () => import('vue-html2pdf')

export default {
  components: {
    flatPickr,
    VueHtml2pdf
  },
  data () {
    return {
      activeUserInfos: null,
      DateDebut: null,
      DateFin: null,
      idOfficine: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).IdOfficine : null,
      status: '',
      filename: 'BR',
      totalbr: 0,
      totalpa: 0,
      totalpvHt: 0,
      totalpvTtc: 0,
      officineName: ''
    }
  },
  computed: {
    officines () {
      return this.$store.state.officine.officines
    },
    br () {
      return this.$store.state.etat.br
    },
    totalPaArticleBr () {
      return this.moneyFormatter(this.$store.getters['etat/totalPaArticleBr'])
    },
    totalPvHtArticleBr () {
      return this.moneyFormatter(this.$store.getters['etat/totalPvHtArticleBr'])
    },
    totalPvTtcArticleBr () {
      return this.moneyFormatter(this.$store.getters['etat/totalPvTtcArticleBr'])
    },
    totalQteArticleBr () {
      return this.moneyFormatter(this.$store.getters['etat/totalQteArticleBr'])
    },
    principale () {
      return this.$store.getters['officine/officineIsPrincipale'](JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).IdOfficine : null)
    }

  },
  methods: {
    goToDetailFacture (id) {
      this.$router.push(`/apps/commandefourn/view/${id}`).catch(() => {})
    },
    moneyFormatter (montant) {
      /* Formatage du calcul */
      const val = (montant / 1).toFixed(0).replace('.', ',')

      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },
    getFournisseurName (id) {
      return this.$store.getters['fournisseur/getFournisseurName'](id)
    },
    paArticleBr (articles) {
      const montant = articles.reduce((accumulator, article) => {
        return accumulator + (article.PrixAchatBrut)
      }, 0)

      return this.moneyFormatter(montant)
    },
    pvHtArticleBr (articles) {
      const montant = articles.reduce((accumulator, article) => {
        return accumulator + (article.PrixVenteHT)
      }, 0)

      return this.moneyFormatter(montant)
    },
    pvTtcArticleBr (articles) {
      const montant = articles.reduce((accumulator, article) => {
        return accumulator + (article.PrixVenteTTC !== 0 ? +article.PrixVenteTTC : +article.PrixVenteHT)
      }, 0)

      return this.moneyFormatter(montant)
    },
    onSelectOfficine (id) {
      const officine = this.$store.state.officine.officines.find((o) => o._id === id)
      this.officineName = officine.NomOffic
    },
    getBROnSpecifiquePeriode () {
      const payload = {
        DateDebut: this.DateDebut,
        DateFin: this.DateFin,
        idOfficine: this.idOfficine,
        status: this.status
      }

      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#button-with-loading',
        type: 'sound',
        scale: 0.45
      })

      this.$store.dispatch('etat/getBROnSpecifiquePeriode', payload)
        .then(() => {
          this.$vs.loading.close('#button-with-loading > .con-vs-loading')
        })
        .catch(err => {
          console.error(err)
          this.$vs.loading.close('#button-with-loading > .con-vs-loading')
        })

    },
    getOfficines () {
      this.$store.dispatch('officine/getOfficines')
        .then(() => {
          this.onSelectOfficine(this.idOfficine)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFournisseurs () {
      this.$store.dispatch('fournisseur/getFournisseurs')
        .then(() => {
        })
        .catch((error) => {
          console.log(error)
        })
    },
    activeUserInfo () {
      this.activeUserInfos = JSON.parse(localStorage.getItem('userInfo'))
    },
    RefreshContent () {
      this.getOfficines()
      this.getFournisseurs()
      this.DateDebut = null
      this.DateFin = null
      this.idOfficine = null
      this.status = null
      this.$refs.filter_card.removeRefreshAnimation(3000)
    },
    printBrToPdf () {

      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#pdf-button-with-loading',
        type: 'sound',
        scale: 0.45
      })

      setTimeout(() => {
        this.$vs.loading.close('#pdf-button-with-loading > .con-vs-loading')
      }, 10000)

      this.$refs.html2Pdf.generatePdf()

    }

  },
  created () {
    if (!(this.$store.state.officine.officines.length > 0)) this.getOfficines()
    if (!(this.$store.state.fournisseur.fournisseurs.length > 0)) this.getFournisseurs()
  }
}
</script>
<style scoped>
.not-data-table{
  display: none;
}

.customtable, .customth, .customtd {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 4px;
  font-size: 12px;
}

.titre_etat_regl{
  border: 1px solid;
  background-color: #CFCFCF;
}
</style>
